import { render, staticRenderFns } from "./patientsPortalChangeInfo.vue?vue&type=template&id=21ece0a2&"
import script from "./patientsPortalChangeInfo.vue?vue&type=script&lang=js&"
export * from "./patientsPortalChangeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports